import { get, post } from 'app/shared/utils/fetchr';

export const getComments = (articleId: number) =>
  get(`/v1/comments/${articleId}`);

export const addComment = ({ articleId, details }) =>
  post(`/v1/comments/${articleId}/add`, details);
